"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSharedRecipeQuery = void 0;
const client_1 = require("@apollo/client");
const recipePreviewFragment_1 = require("../fragments/recipePreviewFragment");
exports.getSharedRecipeQuery = client_1.gql `
  query GetSharedRecipe($shareId: String!) {
    getSharedRecipe(shareId: $shareId) {
      ...RecipePreview
    }
  }

  ${recipePreviewFragment_1.recipePreviewFragment}
`;
//# sourceMappingURL=getSharedRecipe.js.map